import React from 'react';
import PropTypes from 'prop-types';
import FuseTheme from '../global/theme';
import ContentYes from 'material-ui/svg-icons/navigation/check';
import ContentNo from 'material-ui/svg-icons/navigation/close';

const styles = {
    icon: {overflow: 'inherit'},
};

const BooleanIcon = ({record = false}) => {
    if (record === true) {
        return (
            <ContentYes color={FuseTheme.palette.correctColor} styles={styles.icon}/>
        )
    }
    return (
        <ContentNo color={FuseTheme.palette.accent1Color} styles={styles.icon}/>
    )
};

BooleanIcon.propTypes = {
    record: PropTypes.bool,
};

BooleanIcon.defaultProps = {
    style: {padding: 0},
};

export default BooleanIcon;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/BooleanIcon.js